import { Component, Input, OnInit } from '@angular/core';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { EXPIRY_OFFSET_HFT_DATE_FORMAT, MOMENT_DATE_FORMAT, Utils } from '@app/_helpers';
import { OPTION_MODE_STRING, ORDER_MODE } from '@app/_shared/shared.enums';
import { StrategyModal } from '../portfolio-form/portfolio.model';
import *  as moment from 'moment';
import { ExpiryType, StrikeSelectionType } from '../../../../utProto/webApiStrategyEnums_pb';
import { EXPIRY_OFFSET_TYPES_STRING, STRIKE_SELECTION_STRING } from '../portfolio-form/portfolio-form.enums';
import { EXPIRY_WEEKLY_OFFSET_TYPES_STRING, EXPIRY_WEEKLY_OFFSET_TYPES_STRING_LABELS } from '../portfolio-form/portfolio-form.constants';
import { ConfigurationService, SymbolSearchService } from '@app/_shared/providers';
import { EXECUTION_STYLE_NUM } from '../strategy-form/strategy.enums';


interface legInfoTable {
  orderMode: number;
  instrumentType: number;
  expiry: string;
  strikePrice: string;
  lots: number;
  targetProfit: number;
  stopLoss: number;
  stopLossType: number;
  targetProfitType: number;
  symbol: string;
  series: string;
}
@Component({
  selector: 'app-legs-info-table',
  templateUrl: './legs-info-table.component.html',
  styleUrls: ['./legs-info-table.component.scss']
})
export class LegsInfoTableComponent implements OnInit {

  @Input() strategy: StrategyModal;
  isLazyLegAllowed: boolean = true;
  @Input() dependentOnly: boolean = false;

  dataSource = new MatTableDataSource<legInfoTable>();
  ORDER_MODE = ORDER_MODE;
  displayedColumns = ['order_mode', 'instrument', 'expiry', 'strike', 'lots', 'target_profit', 'stop_loss'];
  exchangeCMSelected: boolean;
  constructor(
    private symbolSearchServce: SymbolSearchService,
    private configService: ConfigurationService
  ) {
    this.isLazyLegAllowed = this.configService.remoteConfigCacheObj.DEPENDENT_COMPONENT?.leg_level;
  }

  ngOnInit(): void {
    this.prepDataSource();

  }

  prepDataSource() {
    this.exchangeCMSelected = Utils.getSelectedExchanges(this.strategy.strategySymbol.exchange.toString());
    if (this.exchangeCMSelected) {
      this.displayedColumns = ['order_mode', 'instrument', 'lots', 'symbol', 'series', 'target_profit', 'stop_loss'];
    }
    if (!this.isLazyLegAllowed) {
      this.strategy.StrategyParams.legs.forEach(leg => this.parseLegData(leg));
    } else {
      this.strategy.StrategyParams.legs.forEach(leg => {
        if ((this.dependentOnly && leg.orderExecutionType == EXECUTION_STYLE_NUM.DEPENDENT)
          || (!this.dependentOnly && (!leg.orderExecutionType || leg.orderExecutionType !== EXECUTION_STYLE_NUM.DEPENDENT))) {
          this.parseLegData(leg);
        }
      });
    }
  }

  parseLegData(leg) {
    const expiry = this.getExpiryOffset(leg.legSymbol.expiryType, leg.legSymbol.expiryDate);
    const strike = this.getStrikeOffset(leg.legSymbol.strikeSelection, Utils.applyPrecision((leg.legSymbol.strikeValue)));
    const symbolExists = this.symbolSearchServce.symbolExists(leg.legSymbol.symbol);
    let data: legInfoTable = {
      orderMode: leg.orderMode,
      instrumentType: this.exchangeCMSelected ? "Equity" : OPTION_MODE_STRING[leg.legSymbol.optionMode],
      expiry: expiry,
      strikePrice: strike === 'ATM 0' ? 'ATM' : symbolExists ? strike : null,
      lots: leg.lots,
      symbol: leg.legSymbol?.symbol,
      series: leg.legSymbol?.series,
      targetProfit: Utils.applyPrecision(leg.legExitParams?.targetProfit),
      stopLoss: Utils.applyPrecision(leg.legExitParams?.stopLoss),
      stopLossType: leg.legExitParams?.stopLossType,
      targetProfitType: leg.legExitParams?.targetProfitType
    }
    this.dataSource.data.push(data);
  }

  formatExpiry(expiry: number) {
    return moment(expiry, EXPIRY_OFFSET_HFT_DATE_FORMAT).format(MOMENT_DATE_FORMAT);
  }

  getExpiryOffset(expiryType: number, expiryDate: number) {

    switch (expiryType) {
      case ExpiryType.EXPIRYTYPE_MONTHLY:
        return `Monthly ${EXPIRY_OFFSET_TYPES_STRING[expiryDate]}`;

      case ExpiryType.EXPIRYTYPE_WEEKLY:
        return `Weekly ${EXPIRY_WEEKLY_OFFSET_TYPES_STRING_LABELS[EXPIRY_WEEKLY_OFFSET_TYPES_STRING[expiryDate]]}`;

      case ExpiryType.EXPIRYTYPE_BASIC:
        return this.formatExpiry(expiryDate);

      default:
        return;
    }
  }

  getStrikeOffset(strikeSelection: number, strikeValue: number) {
    switch (strikeSelection) {
      case StrikeSelectionType.STRIKESELECTIONTYPE_ATM:
        return `ATM ${strikeValue > 0 ? '+' : ''}${strikeValue}`;

      case StrikeSelectionType.STRIKESELECTIONTYPE_BASIC:
        return strikeValue.toString();

      case StrikeSelectionType.STRIKESELECTIONTYPE_PRICE_NEAREST:
        return `Price ${strikeValue}`;

      default:
        return;
    }
  }


}
